import { render, staticRenderFns } from "./AdjustResultsParams.vue?vue&type=template&id=607bfe76&lang=pug&"
import script from "./AdjustResultsParams.vue?vue&type=script&lang=ts&"
export * from "./AdjustResultsParams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports